import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { IsActive } from './../../../../model';
import { environment } from './../../../../../environments/environment';
import * as HttpStatus from 'http-status-codes';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';


@Injectable()
export class SiteSummaryService {
  private urlPrefix: string = environment.appUrl;
  constructor(
    private http: HttpClient
  ) { }

  getSummary(siteStatus: number) {
    const url = this.urlPrefix + 'sites?site-status=' + siteStatus + '&customer-status=' + IsActive.both;
    return this.http
      .get(url, {
          observe: 'response'
      })
      .map(
        res => {
          if (res.status === HttpStatus.OK) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/site/site-summary/site-summary.service.ts